function hrVisibilityToggle (targetElement) {
  let height = targetElement.clientHeight
  let scrollHeight = targetElement.scrollHeight
  if (height) {
    targetElement.style.height = scrollHeight + 'px'
    setTimeout(function () {
      targetElement.style.height = '0'
      targetElement.style.paddingTop = '0'
      targetElement.style.paddingBottom = '0'
    }, 1)
  } else {
    targetElement.style.height = scrollHeight + 'px'
    targetElement.style.paddingTop = null
    targetElement.style.paddingBottom = null
  }
}

/* AJAX add-to-cart fallback: opens mini-cart by dispatching `product:added` */
;(function () {
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target
      if (!form || form.tagName !== 'FORM') return
      if (e.defaultPrevented) return
      var action = form.getAttribute('action') || ''
      if (action.indexOf('/cart/add') === -1) return
      if (form.dataset.ajaxCartSubmit === '1') return
      var idInput = form.querySelector('input[name="id"]')
      if (!idInput || !idInput.value) return
      e.preventDefault()
      var submitter = e.submitter || form.querySelector('[type="submit"]')
      if (submitter) submitter.setAttribute('disabled', 'disabled')
      document.dispatchEvent(new CustomEvent('theme:loading:start'))
      var url =
        (window.routes && window.routes.cartAddUrl
          ? window.routes.cartAddUrl
          : '/cart/add') + '.js'
      fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: new URLSearchParams(new FormData(form))
      })
        .then(function (res) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'))
          if (!res.ok) {
            form.dataset.ajaxCartSubmit = '1'
            form.submit()
            return
          }
          var qtyInput = form.querySelector('[name="quantity"]')
          var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1
          document.dispatchEvent(
            new CustomEvent('product:added', {
              bubbles: true,
              detail: { variant: idInput.value, quantity: qty }
            })
          )
          if (submitter) submitter.removeAttribute('disabled')
        })
        .catch(function () {
          document.dispatchEvent(new CustomEvent('theme:loading:end'))
          if (submitter) submitter.removeAttribute('disabled')
          form.dataset.ajaxCartSubmit = '1'
          form.submit()
        })
    },
    false
  )
})()
